import React from 'react';
import { Redirect, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router';
import { DefaultLayout } from '../../../components/layout/default-layout';
import { PageTitleZoneNext } from '../../../components/page-title-zone/page-title-zone-next';
import { TabContent } from '../../../components/tab-content/tab-content';
import { FasitApmRoute } from '../../../apm/fasit-apm-route';
import { useMetaTitle } from '../../../hooks/use-meta-title';
import { joinURL } from '../../../utilities/join-url';
import { forumAllChatsPathName, forumAreaTitle, forumMyChatsPathName, forumNewsPathName, forumNudgePathName, forumSettingsPathName } from '../forum-area-pathnames';
import { ForumCaseworkerTabBar } from './forum-caseworker-tab-bar';
import { ForumChatsTab } from './chats/forum-chats-tab';
import { ForumNewsTab } from './news/forum-news-tab';
import { ForumNudgeTab } from './nudge/forum-nudge-tab';
import { ForumSettingsTab } from './settings/forum-settings-tab';
import { useFeatureToggles } from '../../../feature-toggles';
import { useCanWriteCitizenDialog } from './citizen-dialog-access';

export function ForumCaseworkerPage() {
  const match = useRouteMatch();
  const canWriteCitizenDialog = useCanWriteCitizenDialog();
  const { isFeatureEnabled } = useFeatureToggles();
  const showSettingsTab = isFeatureEnabled('EnableForumCaseworkerAbsence') && canWriteCitizenDialog;
  useMetaTitle(forumAreaTitle);
  return (
    <DefaultLayout>
      <PageTitleZoneNext title={forumAreaTitle} />
      <ForumCaseworkerTabBar showNudgeTab={canWriteCitizenDialog} showSettingsTab={showSettingsTab} />
      <TabContent>
        <Switch>
          <FasitApmRoute path={joinURL(match.path, forumMyChatsPathName)} exact>
            <ForumChatsTab onlyMine />
          </FasitApmRoute>
          <FasitApmRoute path={joinURL(match.path, forumAllChatsPathName)} exact>
            <ForumChatsTab />
          </FasitApmRoute>
          <FasitApmRoute path={joinURL(match.path, forumNewsPathName)} exact>
            <ForumNewsTab canWrite={canWriteCitizenDialog} />
          </FasitApmRoute>
          {canWriteCitizenDialog && (
            <FasitApmRoute path={joinURL(match.path, forumNudgePathName)} exact>
              <ForumNudgeTab />
            </FasitApmRoute>
          )}
          {showSettingsTab && (
            <FasitApmRoute path={joinURL(match.path, forumSettingsPathName)} exact>
              <ForumSettingsTab />
            </FasitApmRoute>
          )}
          <Redirect to={joinURL(match.url, forumMyChatsPathName)} />
        </Switch>
      </TabContent>
    </DefaultLayout>
  );
}
